import { render, staticRenderFns } from "./GameSelect.vue?vue&type=template&id=27d00628"
import script from "./GameSelect.vue?vue&type=script&lang=js"
export * from "./GameSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports